// Formats a timestamp like "06 Oct 2026, 04:25 PM". Returns '' for missing/invalid input.
export const formatDateTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date
    .toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    })
    .replace(/\b(am|pm)\b/, (m) => m.toUpperCase());
};

// Reads review audit info (who approved/rejected a post and when). The API may name
// these fields approvedBy/approvedAt or rejectedBy/rejectedAt, or reuse the
// updatedBy/updatedAt written by /approve/posts.
export const getPostReview = (post) => {
  if (post?.status === 'published') {
    return {
      label: 'Approved',
      by: post.approvedBy || post.approvedByName || post.updatedBy || '',
      at: post.approvedAt || post.approvedDate || post.updatedAt || ''
    };
  }
  if (post?.status === 'rejected') {
    return {
      label: 'Rejected',
      by: post.rejectedBy || post.rejectedByName || post.updatedBy || '',
      at: post.rejectedAt || post.rejectedDate || post.updatedAt || ''
    };
  }
  return { label: '', by: '', at: '' };
};
